import PropTypes from 'prop-types';

import { TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { TruncatedTypography } from 'src/components/TruncatedTypography';

import { useStyles } from './useStyles';

const NO_RESULTS = 'No results found';

export const EmptyMenuState = ({ searchText, emptyText }) => {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <TruncatedTypography
        variant={TYPOGRAPHY_VARIANT.regular14}
        align="center"
      >
        {searchText ? `${NO_RESULTS} for "${searchText}"` : emptyText}
      </TruncatedTypography>
    </div>
  );
};

EmptyMenuState.propTypes = {
  searchText: PropTypes.string,
  emptyText: PropTypes.string,
};

EmptyMenuState.defaultProps = {
  searchText: '',
  emptyText: NO_RESULTS,
};
